// Lokasyon Yönetimi (WMS) sayfası — Ağaç Görünümü sekmesi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'wms.locationManager';

export const wmsLocationManagerGuide = (t: TFunction): GuideContent => ({
  layout: 'tabbed',
  title: t(`${G}.title`, 'Lokasyon Yönetimi nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Deponun adres yapısını (bölge, koridor, peron, raf, kat, bölme) burada kurarsınız. Mal kabulde ürünler bu raflara yerleştirilir, toplayıcı da ürünü bu raflardan alır. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Depo adı, doluluk, SortOrder Hesapla'),
    tabs: t(`${G}.regions.tabs`, 'Görünüm sekmeleri'),
    body: t(`${G}.regions.body`, 'Lokasyon ağacı ve ayrıntı'),
  },
  navItems: [
    t(`${G}.nav.map`, '2D Görsel Harita'),
    t(`${G}.nav.tree`, 'Ağaç Görünümü'),
  ],
  steps: [
    {
      region: 'tabs',
      title: t(`${G}.s1.title`, '1. Görünümü seçin'),
      text: t(`${G}.s1.text`, '"2D Görsel Harita" sekmesinde depoyu çizerek kurarsınız; o sekmedeyken başlıktaki (i) düğmesi harita rehberini açar. "Ağaç Görünümü" sekmesinde lokasyonları liste hâlinde ekler, düzenler ve barkodlarını basarsınız. İki görünüm aynı kayıtları gösterir.'),
    },
    {
      region: 'header',
      title: t(`${G}.s2.title`, '2. Doluluk oranını okuyun'),
      text: t(`${G}.s2.text`, 'Başlıktaki "Doluluk" etiketi, aktif ve toplanabilir lokasyonlardan kaçında stok bulunduğunu gösterir (dolu / toplam). Oran %85 ve üstündeyse etiket turuncu olur.'),
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Ağaçta lokasyon ekleyin'),
      text: t(`${G}.s3.text`, '"Bölge Ekle" ile başlayın. Sonra her satırdaki "… Ekle" düğmesiyle alt lokasyon ekleyin: Bölge altına Koridor veya Peron, Koridor altına Peron, Peron altına Raf, Raf altına Raf veya Kat, Kat altına Bölme. Açılan pencerede Tip, Kod ve Ad girilir.'),
      tips: [
        t(`${G}.s3.tip1`, 'Ağaçta raflar renklidir: üzerinde stok olan raf turuncu, boş raf yeşil görünür.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Toplu raf oluşturun'),
      text: t(`${G}.s4.text`, 'Peron veya raf satırındaki "Toplu Raf Oluştur" düğmesi tek seferde çok sayıda lokasyon açar. Raf Sayısı, Kat Sayısı, Bölme Sayısı ve Başlangıç No girin; Önek boşsa üst lokasyonun kodu kullanılır. Önizlemede oluşacak kodları görürsünüz (ör. P01-R01-L01-B01); barkodlar otomatik hazırlanır.'),
    },
    {
      region: 'body',
      title: t(`${G}.s5.title`, '5. Lokasyon ayrıntısını düzenleyin, barkod basın'),
      text: t(`${G}.s5.text`, 'Ağaçta bir lokasyona tıklayınca sağda Kod, Ad, Tip, Koridor, Taraf, Kapasite, Aktif ve Toplanabilir alanları açılır; değiştirip kaydedin. Barkod alanında "Oluştur" ile barkod üretilir, "Yazdır" ile etiketi basılır. Altta alt lokasyonlar ve "Raftaki Ürünler" (ürün, barkod, miktar) listelenir.'),
      tips: [
        t(`${G}.s5.tip1`, 'Toplama listesi ürünü yalnız aktif ve "Toplanabilir" işaretli raf / bölmelerden gösterir. Birden çok rafta varsa en çok miktarın olduğu raf, eşitlikte toplama sırası önce gelen raf seçilir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s6.title`, '6. Lokasyon silme'),
      text: t(`${G}.s6.text`, 'Ayrıntıdaki Sil düğmesi lokasyonu bütün alt lokasyonlarıyla birlikte siler; onay penceresi kaç alt lokasyonun silineceğini söyler. Bu işlem geri alınamaz.'),
      tips: [
        t(`${G}.s6.tip1`, 'Silinen rafta stok varsa stok miktarı silinmez; ürünler depoda lokasyonsuz kalır. Yeniden toplanabilmeleri için bir rafa yerleştirilmeleri gerekir.'),
      ],
    },
    {
      region: 'header',
      title: t(`${G}.s7.title`, '7. Toplama sırasını hesaplayın'),
      text: t(`${G}.s7.text`, '"SortOrder Hesapla" tüm lokasyonlara toplama sıra numarası verir: haritadaki giriş noktasından başlayıp raflar arasında yılan biçiminde ilerler. Toplayıcının rotası bu sıraya göre çıkar. Haritada değişiklik yaptıysanız önce Kaydet\'e basın, sonra hesaplayın; hesap kaydedilmiş haritaya göre yapılır.'),
      tips: [
        t(`${G}.s7.tip1`, 'Engeller (duvar, sütun vb.) sıraya girmez.'),
      ],
    },
  ],
});
